<script setup lang="ts">
import { computed, ref } from 'vue';

import type { GameEntity } from '../types';

const props = defineProps<{
  entities: GameEntity[];
}>();

const emit = defineEmits<{
  (e: 'selectEntity', entityId: number): void;
}>();

const filter = ref('');

const filteredEntities = computed(() => {
  const f = filter.value.toLowerCase();
  if (!f) return props.entities;

  return props.entities.filter(
    (e) =>
      e.id.toString().includes(f) ||
      (e.components.DisplayName?.name || '').toLowerCase().includes(f) ||
      Object.keys(e.components).some((c) => c.toLowerCase().includes(f)),
  );
});

const toRender = computed(() => filteredEntities.value.slice(0, 200));
const remainingCount = computed(() =>
  Math.max(0, filteredEntities.value.length - 200),
);
</script>

<template>
  <div>
    <input
      v-model="filter"
      type="text"
      placeholder="Filter entities..."
      style="
        width: 100%;
        padding: 5px;
        margin-bottom: 10px;
        background: #222;
        border: 1px solid #555;
        color: white;
        box-sizing: border-box;
      "
    >
    <div style="max-height: 500px; overflow-y: auto">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Components</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="e in toRender"
            :key="e.id"
            class="clickable-row"
            @click="emit('selectEntity', e.id)"
          >
            <td>{{ e.id }}</td>
            <td>{{ e.components.DisplayName?.name || '' }}</td>
            <td style="font-size: 0.9em; color: #aaa">
              {{ Object.keys(e.components).join(', ') }}
            </td>
          </tr>
          <tr v-if="remainingCount > 0">
            <td
              colspan="3"
              style="text-align: center; color: #888"
            >
              ... and {{ remainingCount }} more ...
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style scoped>
.clickable-row {
  cursor: pointer;
  transition: background-color 0.2s;
}

.clickable-row:hover {
  background-color: #333;
}
</style>
